var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 23" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "score_triangle"
    ),
    React.createElement(
      "g",
      { id: "\u30EC\u30A4\u30E4\u30FC_2", "data-name": "\u30EC\u30A4\u30E4\u30FC 2" },
      React.createElement(
        "g",
        { id: "area_record" },
        React.createElement(
          "g",
          { id: "item_score" },
          React.createElement(
            "g",
            { id: "score_12" },
            React.createElement(
              "g",
              { id: "score_triangle" },
              React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M12 4.32L20.7 21H3.3L12 4.32M12 0L0 23h24L12 0z", id: "item_triangle" })
            )
          )
        )
      )
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-svg-loader/lib/loader.js!./src/components/atoms/icon/images/status2.svg
// module id = 1056
// module chunks = 0